/* istanbul ignore file */
import { Paragraph } from '@econsult/econsult-ui/dist/components/shared/typography';
import styled from 'styled-components';

export const ParagraphTiny = styled(Paragraph).attrs({ typography: 'ParagraphTinyRegular' })`
  margin: 0;
  color: ${({ theme }) => theme.colorPrimaryPrimary100};
`;

export const ParagraphTinyHeavy = styled(Paragraph).attrs({ typography: 'ParagraphTinyHeavy' })`
  margin: 0;
  color: ${({ theme }) => theme.colorPrimary100};
`;

export const ParagraphSmallRegular = styled(Paragraph).attrs({ typography: 'ParagraphSmallRegular' })`
  margin: 0;
  color: ${({ theme }) => theme.colorPrimaryPrimary100};
`;

export const ParagraphXsmallRegular = styled(Paragraph).attrs({ typography: 'ParagraphXsmallRegular' })`
  margin: 0;
  color: ${({ theme }) => theme.colorPrimaryPrimary100};
`;

export const ParagraphSmallHeavy = styled(Paragraph).attrs({ typography: 'ParagraphSmallHeavy' })`
  margin: 0;
  color: ${({ theme }) => theme.colorPrimaryPrimary100};
`;

export const ParagraphXSmallHeavy = styled(Paragraph).attrs({ typography: 'ParagraphXsmallHeavy' })`
  margin: 0;
  color: ${({ theme }) => theme.colorPrimaryPrimary100};
`;

export const ParagraphSmallCapsHeavy = styled(Paragraph).attrs({ typography: 'ParagraphSmallCapsHeavy' })`
  margin: 0;
  color: ${({ theme }) => theme.colorPrimaryPrimary100};
`;
